import type { SearchSessionSummary } from '@/hooks/use-search-sessions'

export function sortSearchSessionsByDate(
  sessions: SearchSessionSummary[],
): SearchSessionSummary[] {
  return [...sessions].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  )
}

/** One current session per context — API deletes prior rows on new search. */
export function filterVisibleSearchSessions(
  sessions: SearchSessionSummary[],
  _showArchived = false,
): SearchSessionSummary[] {
  const sorted = sortSearchSessionsByDate(sessions)
  if (sorted.length === 0) return []
  return [sorted[0]]
}

export function getLatestSearchSessionId(sessions: SearchSessionSummary[]): string | null {
  return filterVisibleSearchSessions(sessions)[0]?.id ?? null
}
